import {Router} from "@angular/router";
import {appRoutes} from "@numizmat/constants";
import {Component, inject} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";

import {ToastrService} from "ngx-toastr";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {AccountSettingsApiService} from "@numizmat/services/account";
import {DeleteProfileRequest} from "@numizmat/services-models/account";

@Component({
  selector: 'nz-delete-profile-modal',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './delete-profile-modal.component.html',
  styleUrl: './delete-profile-modal.component.scss'
})
export class DeleteProfileModalComponent {
  private router: Router = inject(Router);
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private toastrService: ToastrService = inject(ToastrService);
  private accountSettingsApiService: AccountSettingsApiService = inject(AccountSettingsApiService);

  protected loading: boolean = false;
  protected errorMessage: string = '';
  protected form: FormGroup = this.initializeForm();

  protected onSubmit(): void {
    this.loading = true;
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      this.loading = false;
      return;
    }
    const formValue = this.form.getRawValue();
    const request: DeleteProfileRequest = {
      password: formValue.password
    };
    this.accountSettingsApiService.deleteProfile(request).subscribe({
      next: response => {
        this.loading = false;
        if (response.success) {
          this.toastrService.success(response.successMessage);
          this.router.navigate([appRoutes.root, appRoutes.account, appRoutes.login]).then();
          this.closeModal();
        } else {
          this.errorMessage = response.errorMessage;
        }
      }
    });
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }

  private initializeForm() {
    return new FormGroup({
      password: new FormControl(null, [Validators.required])
    });
  }

  get password() {
    return this.form.get('password');
  }
}
